import { translationsReducer } from 'js/src/data/translations/translations-reducers';

/* MODULE EXPORTS */
export * from 'js/src/data/translations/translations-types';
export * from 'js/src/data/translations/translations-actions';
export * from 'js/src/data/translations/translations-selectors';
export * from 'js/src/data/translations/translations-operations';

export default translationsReducer;
